<template>
  <div style="position: absolute; left: 0; top: 0; z-index: 1500; width: 100%; background-color: #F1F1F1;">
    <div style="display: flex; align-items: center; width: 100%; min-height: 100vh;" id="cont_main">
          <div class="col-md-4 offset-md-4 col-xs-10 offset-xs-1 box-shadow-2 p-0">
              <div class="card border-grey border-lighten-3 m-0">
                  <div class="card-header no-border">
                      <div class="card-title text-xs-center">
                          <div class="p-1">
                            <!-- <img  src="../assets/pictures/me_logo.png" alt="branding logo"> -->
                            <svg style="max-width: 70%; min-width: 50%; height: 2.5rem;" class="me_logo" />
                            <ul class="nav navbar-nav float-xs-right">  
                              <li class="dropdown dropdown-language nav-item">
                                <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn dropdown-toggle nav-link">
                                
                                  <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i>
                                
                                </a>
                                
                                <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                                  <a class="dropdown-item" :id="lang" v-for="(lang, index) in listLanguages" :key="index" @click="changeLanguage(lang)">
                                    <i class="flag-icon" :class="$i18n.getLocaleMessage(lang).lang.logo"></i> {{ $i18n.getLocaleMessage(lang).lang.title }}
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>
                          
                      </div>
                      
                      <h6 class="card-subtitle line-on-side text-muted text-xs-center font-small-3">
                        <span v-if="!register">{{$t('login.lbl.login')}}</span>
                        <span v-if="register">{{$t('registr.lbl.reg') + ' ' + $t('titles.roles.' + dataRegistr.role + '.title')}}</span>
                      </h6>
                  </div>
                  <div class="card-body collapse in">
                      <div class="card-block">
                          <div class="form-horizontal form-simple">

                            <fieldset class="form-group position-relative has-icon-left mb-otstup">
                                <input type="text" v-model.trim="$v.dataAuthorization.user.$model" class="form-control form-control-lg input-lg" id="user-name" :placeholder="$t('users.table.login')" v-on:keyup.enter="$refs.login.click()" :class="{ 'border-danger': $v.dataAuthorization.user.$error }" required>
                                <div class="form-control-position">
                                    <i class="icon-head"></i>
                                </div>
                                <span v-if="$v.dataAuthorization.user.$error" style="color: red">
                                  <span class="d-flex" v-if="!$v.dataAuthorization.user.required">{{$t('errors.required')}}</span>
                                  <span class="d-flex" v-if="!$v.dataAuthorization.user.minLength">{{$t('errors.minLength')}} {{$v.dataAuthorization.user.$params.minLength.min}} </span>
                                </span>
                            </fieldset>

                            <fieldset class="form-group position-relative has-icon-left mb-otstup">
                                <input :type="[dataAuthorization.visible ? 'text' : 'password']" v-model.trim="$v.dataAuthorization.password.$model" class="form-control form-control-lg input-lg" id="user-password" :placeholder="$t('login.lbl.password')" v-on:keyup.enter="$refs.login.click()" :class="{ 'border-danger': $v.dataAuthorization.password.$error }" required>
                                <div class="form-control-position hand" @click="dataAuthorization.visible = !dataAuthorization.visible">
                                    <!-- <i class="icon-key3"></i> -->
                                    <i :class="[dataAuthorization.visible ? 'icon-eye3' : 'icon-eye-blocked']"></i>
                                </div>
                                <span v-if="$v.dataAuthorization.password.$error" style="color: red">
                                  <span class="d-flex" v-if="!$v.dataAuthorization.password.required">{{$t('errors.required')}}</span>
                                  <span class="d-flex" v-if="!$v.dataAuthorization.password.minLength">{{$t('errors.minLength')}} {{$v.dataAuthorization.password.$params.minLength.min}} </span>
                                </span>
                            </fieldset>

                            <!-- <div class="row">
                              <div class="col-md-12">
                                <div class="d-flex hand" @click="dataAuthorization.visible = !dataAuthorization.visible" style="align-items: center">
                                  <i :class="[dataAuthorization.visible ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i> &nbsp; <span class="menu-title">{{ $t('titles.showPassword') }}</span>
                                </div>
                              </div>
                            </div> -->

                            <!-- <div class="row">
                              <div class="col-md-12">
                                <fieldset class="form-group position-relative has-icon-left mb-otstup text-md-right" v-if="!register">
                                  <router-link :to="{ name: 'recover-password'}" class="card-link">
                                    <i class="icon-lock"></i> <span class="menu-title">{{ $t('titles.forgotPasswrd') }}</span>
                                  </router-link>
                                </fieldset>
                              </div>
                            </div> -->

                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" >
                                <input :type="[dataAuthorization.visible ? 'text' : 'password']" v-model.trim="$v.dataRegistr.password2.$model" class="form-control form-control-lg input-lg" :class="{ 'border-danger': $v.dataRegistr.password2.$error }" id="user-password2" :placeholder="$t('registr.lbl.confirmPass')" required>
                                <div class="form-control-position hand" @click="dataAuthorization.visible = !dataAuthorization.visible">
                                  <!-- <i class="icon-key3"></i>   -->
                                  <i :class="[dataAuthorization.visible ? 'icon-eye3' : 'icon-eye-blocked']"></i>
                                </div>
                                <span v-if="$v.dataRegistr.password2.$error" style="color: red">
                                  <span class="d-flex" v-if="!$v.dataRegistr.password2.required">{{$t('errors.required')}}</span>
                                  <span class="d-flex" v-if="!$v.dataRegistr.password2.sameAsPassword">{{$t('errors.sameAs')}}</span>
                                </span>
                            </fieldset>

                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" >
                                <input type="text" v-model.trim="$v.dataRegistr.email.$model" class="form-control form-control-lg input-lg" :class="{ 'border-danger': $v.dataRegistr.email.$error }" :placeholder="$t('registr.lbl.email')" required>
                                <div class="form-control-position">
                                    <i class="icon-email"></i>
                                </div>
                                <span v-if="$v.dataRegistr.email.$error" style="color: red">
                                  <span class="d-flex" v-if="!$v.dataRegistr.email.required">{{$t('errors.required')}}</span>
                                  <span class="d-flex" v-if="!$v.dataRegistr.email.email">{{$t('errors.email')}} </span>
                                </span>
                            </fieldset>

                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" >
                                <input type="text" v-model.trim="$v.dataRegistr.username.$model" class="form-control form-control-lg input-lg" :class="{ 'border-danger': $v.dataRegistr.username.$error }" :placeholder="$t('registr.lbl.pib') " required>
                                <div class="form-control-position">
                                    <i class="icon-head"></i>
                                </div>
                                <span v-if="$v.dataRegistr.username.$error" style="color: red">
                                  <span class="d-flex" v-if="!$v.dataRegistr.username.required">{{$t('errors.required')}}</span>
                                </span>
                            </fieldset>

                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" >
                              <input type="text" id="contact" class="form-control form-control-lg input-lg" :class="{ 'border-danger': $v.dataRegistr.phone.$error }" :placeholder="$t('users.table.phone')" v-model.trim="$v.dataRegistr.phone.$model">
                              <div class="form-control-position">
                                <i class="icon-address-book" ></i>
                              </div>
                              <span v-if="$v.dataRegistr.phone.$error" style="color: red">
                                <span class="d-flex" v-if="!$v.dataRegistr.phone.required">{{$t('errors.required')}}</span>
                              </span>
                            </fieldset>

                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" >
                              <input type="text" id="edrpo" class="form-control form-control-lg input-lg" :class="{ 'border-danger': $v.dataRegistr.edrpo.$error }" :placeholder=" $t('registr.lbl.edrpo')" @change="findClient()" v-model.trim="$v.dataRegistr.edrpo.$model">
                              <div class="form-control-position">
                                <a @click="findClient()"><i class="icon-search4" ></i></a>
                              </div>
                              <span v-if="$v.dataRegistr.edrpo.$error" style="color: red">
                                <span class="d-flex" v-if="!$v.dataRegistr.edrpo.required">{{$t('errors.required')}}</span>
                              </span>

                            </fieldset>

                            <fieldset v-show="register" class="form-group position-relative has-icon-left mb-otstup" disabled>
                                <input type="text" v-model="dataRegistr.nameClient" class="form-control form-control-lg input-lg" :placeholder=" $t('registr.lbl.organization')">
                                <div class="form-control-position">
                                    <i class="icon-bank"></i>
                                </div>
                            </fieldset>

                            <fieldset v-show="register" class="form-group position-relative has-icon-left">                                
                                <input type="file" name="file" id="file" class="inputfile" accept="image/x-png,image/jpeg" @change="onUploadImg"/>
                                <center>
                                  <a>{{$t('registr.lbl.logo')}}</a>
                                  <label id="file_loader" for="file"><a class="btn btn-warning btn-min-width">
                                    <i class="icon-upload3"></i> {{ $t('tasks.buttons.file') }}</a>
                                  </label>
                                </center>
                            </fieldset>

                            <div class="col-md-12 mt-1" v-if="register">
                                <div style="display: flex; justify-content: center;">
                                    <div class="hand" style="max-width: 60%; position: relative; margin-right: 1%; margin-top: 1%;" @click="image = {name: null, data: null}">
                                        <img v-bind:src="image.data" style="width:100%" />
                                    </div>
                                </div>
                            </div>

                            <button v-if="!register" ref="login" type="button" class="btn btn-auth btn-lg btn-block" @click="checkForm()"><i class="icon-unlock2"></i> {{ $t('login.btn.login') }}</button>
                            <button v-else type="button" class="btn btn-auth btn-lg btn-block"  @click="checkForm()"><i class="icon-unlock2"></i> {{ $t('registr.btn.reg') }}</button>

                            
                            <button type="button" class="btn btn-auth btn-lg btn-block" @click="$router.push({ name: 'appeal', params: {}, replace: true});">
                              {{ $t('problem.titles.add') }}
                            </button>

                          </div>
                      </div>
                  </div>
                  <div class="card-footer">
                      <div class="d-flex">
                          <p v-if="!register" class="float-sm-right text-xs-center m-0">{{ $t('registr.lbl.not_existing')}}: 
                            <button type="button" class="btn btn-auth btn-sm" @click="register = true; dataRegistr.role = $store.state.roles[0].val; $v.$reset()">{{ $t('registr.lbl.regCl') }}</button>
                            {{$t('registr.lbl.or')}}
                            <button type="button" class="btn btn-auth btn-sm" @click="register = true; dataRegistr.role = $store.state.roles[3].val; $v.$reset()">{{ $t('registr.lbl.regServ') }}</button>

                          </p>  
                          <p v-else class="float-sm-right text-xs-center m-0">{{ $t('registr.lbl.existing') }} ? 
                            <button type="button" class="btn btn-auth btn-sm" @click="register = false; $v.$reset()" > {{ $t('login.lbl.login') }}</button>
                          </p>
                      </div>
                      
                      
                  </div>
              </div>
          </div>

      </div>

  </div>
</template>

<script>
import { required, minLength,  sameAs, email } from 'vuelidate/lib/validators'
    export default {
      name: "Login",
      components: {},
      data() {
          return {
            image: {name: null, data: null},
            image2: {name: null, data: null},
            errors: [],
            submitStatus: null,
            dataAuthorization: {
                user: null,
                password: null,
                visible: false,
                ip: null,
            },
            dataRegistr: {
              password2: null,
              username: null,
              role: '',
              phone: null,
              email: null,
              edrpo: null,
              nameClient: null,
              guidClient: null,
              logo_organization: null,
              type: "1",
            },
            register: false,

            
          };
        },
        validations: {
          dataAuthorization:{
            user:{
              required,
              minLength: minLength(4)
            },
            password:{
              required,
              minLength: minLength(1)
            }
          },
          dataRegistr:{
            password2: {required, sameAsPassword: sameAs( function(){return this.dataAuthorization.password;} ) },
            email:{ required, email },
            username:{ required },
            phone:{ required },
            edrpo:{ required },
            nameClient:{ required }
          },
            
        },
        methods: {
          Login() {
              this.dataAuthorization.ip = '';
              
              window.localStorage.clear();

              localStorage.removeItem('reloaded');

              if (!this.$v.dataAuthorization.password.$error 
                    && !this.$v.dataAuthorization.user.$error) {
                this.makeQuery("/service/loginService", { dataAuthorization: this.dataAuthorization })
                .then(res => {
                    if(res != null){

                      this.$store.commit('setGuidUser', res.userGuid );
                      this.$store.commit('setUserToken', res.session );
                      
                      this.$store.state.userName = res.name;
                      this.$store.state.user = res.username;
                      this.$store.state.email = res.email;
                      
                      let clName = res.clientName;
                      if( ( !this.isValid(clName) ) || (clName == 'null')){
                        clName = 'СП ТОВ Модерн-Експо';
                      }
                      this.$store.state.clientName = clName;
                      
                      this.$store.state.guidClient = res.clientGuid;
                      this.$store.state.clientEdrpo = res.clientEdrpo;
                      this.$store.state.ip = this.dataAuthorization.ip;

                      let roles = '';
                      if(res.roleAdmin == true){
                        this.$store.commit('setAdmin', true );
                        roles = roles + 'admin,';
                      }
                      if(res.roleCourier == true){
                        //this.$store.state.listRole.roleCourier = res.roleCourier;
                        this.$store.commit('setRoleCourier', true );
                        roles = roles + 'roleCourier,';
                      }
                      if(res.roleDispatcher == true){
                        //this.$store.state.listRole.dispatcher = res.roleDispatcher;
                        this.$store.commit('setDispatcher', true );
                        roles = roles + 'dispatcher,';
                      }
                      if(res.roleClient == true){
                        //this.$store.state.listRole.client = res.roleClient;
                        this.$store.commit('setClient', true );
                        roles = roles + 'client,';
                      }
                      if(res.roleService == true){
                        //this.$store.state.listRole.service = res.roleService;
                        this.$store.commit('setService', true );
                        roles = roles + 'service,';
                      }
                      if(res.roleServiceOrg == true){
                        //this.$store.state.listRole.serviceOrg = res.roleServiceOrg;
                        this.$store.commit('setServiceOrg', true );
                        roles = roles + 'serviceOrg,';
                      }
                      if(res.roleUser == true){
                        //this.$store.state.listRole.dispatcher = res.roleUser;
                        this.$store.commit('setUser', true );
                        roles = roles + 'user,';
                      }
                      if(roles.length > 1)
                      roles = roles.slice(0, -1);
                      
                      localStorage.setItem('ip', this.dataAuthorization.ip);
                      localStorage.setItem('user',  this.dataAuthorization.user);
                      localStorage.setItem('userGuid',       res.userGuid);
                      localStorage.setItem('email',       res.email);
                      localStorage.setItem('username',       this.dataAuthorization.user);
                      localStorage.setItem('user-token', res.session);
                      localStorage.setItem('role', roles);
                      localStorage.setItem('clientName',  clName);
                      localStorage.setItem('clientEdrpo',       res.clientEdrpo);
                      localStorage.setItem('guidClient',       res.clientGuid);
                      localStorage.setItem('name',       res.name);
                      
                      if ( this.isValid(res.image) ){
                        localStorage.setItem('profileImg', "data:image/jpg;base64," + res.image);
                        this.$store.commit('setProfilePhoto',"data:image/jpg;base64," + res.image);
                      }

                      if(res.lenguage != undefined){
                        let lang = res.lenguage.toLowerCase();
                        this.changeLanguage(lang);
                      }

                      if (this.$store.getters.getUserToken != null) {//this.$store.state.userToken
                        this.$emit('loggedIn')
                        if (this.$route.params.nextUrl != null) {
                          this.$store.state.isLoading = false;
                          this.$router.push(this.$route.params.nextUrl);
                        } else {
                          this.$store.state.isLoading = false;
                          this.$router.push({ name: 'dashboard-layout'});
                        }
                      }

                    }
                })
                .catch(result => {this.showNotification('custom-error','Error',result); });
              }
          },
          Registration() {
            let dataRequest = {
                //userGuid: "",
                username: this.dataRegistr.username,
                login: this.dataAuthorization.user,
                password: this.dataAuthorization.password,
                email: this.dataRegistr.email,
                edrpo: this.dataRegistr.edrpo,
                guidClient: this.dataRegistr.guidClient,
                nameClient: this.dataRegistr.nameClient,
                tel: this.dataRegistr.phone,
                type: "1",
                role: this.dataRegistr.role,
                photo: null,
                system: 3,
                language: this.$i18n.locale
            };
            
            if (this.isValid(this.image2.data)){
              dataRequest.photo = this.image2.data;
            }
            this.makeQuery("/service/registrationUser", {dataRequest: dataRequest})
            .then(result => {
                this.showNotification('custom-success','Registration','Successfully registered ' + this.dataAuthorization.user);
                this.register = false;
            })
            .catch(result => {this.showNotification('custom-error','Error',result); });
          },
          findClient(){
            if ( this.isValid(this.dataRegistr.edrpo) ){
              //this.listClients = [];
              let dataRequest = {
                  edrpo: this.dataRegistr.edrpo
              };
              if (dataRequest.edrpo.length > 4){
                
                this.makeQuery("/service/getClient", {dataRequest: dataRequest})
                .then(result => {
                  //this.listClients = result;
                  this.dataRegistr.guidClient = result.guidClient;
                  this.dataRegistr.nameClient = result.name;

                  if(this.isValid(this.dataRegistr.nameClient) == false){
                    this.dataRegistr.nameClient = null;
                    this.dataRegistr.guidClient = null;

                    this.showNotification('custom-info','Search','Client not found!');
                  }
                })
                .catch(result => {this.showNotification('custom-error','Error',result); });

              }
            } else {
              this.dataRegistr.nameClient = null;
              this.dataRegistr.guidClient = null;
            }
          },
          onUploadImg(e){
            
            let tt = null;
            let _this = this;
            if (e.target.files.length > 0){
                for (let i = 0; i < e.target.files.length; i++) {
                  const element = e.target.files[i];
                  const reader = new FileReader();
                  reader.readAsDataURL(element);
                  reader.onload = e => {

                    var img = new Image;
                    img.onload = function() {
                      if(img.width > 1500){
                        //зжимання
                        var w = img.width;
                        var h = img.height;
                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d'); // Создаем узел атрибута
                        var anw = document.createAttribute("width"); 
                        anw.nodeValue = w;
                        var anh = document.createAttribute("height");
                        anh.nodeValue = h;
                        canvas.setAttributeNode(anw);
                        canvas.setAttributeNode(anh);
                        ctx.drawImage(img, 0, 0, w, h);
                        // Чем меньше значение .7, тем более размытым будет нарисованное изображение
                        var base64Img = canvas.toDataURL('image/jpeg',.6);
                        //зжимання

                        tt = (base64Img).split(',');
                      } else {
                        tt = (img.src).split(',');
                      }

                      _this.image = {name: element.name, data: tt[0] + ',' + tt[1] };
                      _this.image2 = {name: element.name, data: tt[1]};
                    }
                    img.src = e.target.result;
                  };                        
              }
            }

          },
          checkForm(){
            this.errors = [];
            this.$v.$touch();

            if (this.register){
              if (this.$v.$invalid) {
                this.submitStatus = 'ERROR';
                return
              } 
              this.Registration();
            } else 
            if(!this.$v.dataAuthorization.password.$error && !this.$v.dataAuthorization.user.$error){
              this.$v.$reset();
              this.Login();
            }
          },
          

        },
        computed:{
          listLanguages(){
            let arrLang = [];
            for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
              arrLang[this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id] = this.$i18n.availableLocales[i];
            }
            return arrLang;
          },
        },
        watch:{},
        mounted () {
          localStorage.removeItem('profileImg');
        }
    }
</script>

<style scoped>

#cont_main{
  background-image: url('../assets/pictures/1.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}
.me_logo{
  background-image: url(../assets/icons/me_text.svg);
  background-size: contain;
  color: transparent !important;
  background-color: transparent !important;
  background-repeat: no-repeat;
}
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
#file_loader {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
	cursor: pointer;
}

.border-danger{
  border: 3px solid #DA4453 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue